import React from "react";
import styled from "styled-components";
import { Dispatch } from "redux";
import { RetrunPrevQuestion } from "../store/chatmessage/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import values from "lodash/values";
import { INode, ReactionItemType } from "../store/chatmessage/types";

const SelectBtn = styled.div<{ color: string }>`
    width: 90%;
	padding: 5px;
	font-size: 13px;
	margin: 10px 0 0;
	cursor: pointer;
	color: #fff;
	background: ${props => props.color};
	border: 1px solid ${props => props.color};
	border-radius: 5px;
	transition: 0.3s ease-out;

	&:hover {
		background transparent;
		color: ${props => props.color};
	}
`;

interface IProps {
  color: string;
  dispatch: Dispatch;
  id: string;
  prev_id: string;
  chatBotBaseData: any;
}

const getParentNode = (chatbotBaseData: any, id: string) => {
  const chatBotBaseDataArray = values(chatbotBaseData);
  const parentArray = chatBotBaseDataArray.filter((node: INode) => {
    if (node.children.includes(id)) {
      return node;
    } else {
      return null;
    }
  });
  if (parentArray.length > 0) return parentArray;
  return [];
};

const searchPrevQuestion = (chatbotBaseData: any, id: string): INode => {
  const chatBotBaseDataArray = values(chatbotBaseData);
  const parentNodeArray = getParentNode(chatbotBaseData, id);
  if (parentNodeArray.length > 0) {
    const parentNode = parentNodeArray[0];
    if (chatbotBaseData[parentNode.id].type === ReactionItemType.OPERATOR) {
      return parentNode;
    } else {
      return searchPrevQuestion(chatbotBaseData, parentNode.id);
    }
  }
  return chatBotBaseDataArray[0];
};

const RetrunPrevQuestionBtn: React.FC<IProps> = ({
  color,
  dispatch,
  id,
  prev_id,
  chatBotBaseData
}) => {
  const RetrunPrev = () => {
    const previousQuestion = searchPrevQuestion(chatBotBaseData, prev_id);
    previousQuestion.prev_id = id;
    dispatch(RetrunPrevQuestion(previousQuestion));
  };
  return (
    <SelectBtn color={color} onClick={() => RetrunPrev()}>
      <FontAwesomeIcon icon={faUndo} size="1x" /> 1つ前の質問に戻る
    </SelectBtn>
  );
};

export default RetrunPrevQuestionBtn;
